import React from "react";
import MaskedInput from "react-text-mask";
import Input from "@material-ui/core/Input";
import InputLabel from "@material-ui/core/InputLabel";
import FormControl from "@material-ui/core/FormControl";
import FormHelperText from "@material-ui/core/FormHelperText";
import { kebabCase } from "lodash";

function MInput(props) {
  const { inputRef, defaultValue, ...other } = props;
  return (
    <MaskedInput
      pattern="\([0-9]{3}\)\s[0-9]{3}.[0-9]{4}"
      defaultValue={defaultValue}
      {...other}
      ref={inputRef}
      mask={[
        "(",
        /[1-9]/,
        /\d/,
        /\d/,
        ")",
        " ",
        /\d/,
        /\d/,
        /\d/,
        ".",
        /\d/,
        /\d/,
        /\d/,
        /\d/
      ]}
      placeholderChar={"\u2000"}
    />
  );
}

export default function TextMaskCustom(props) {
  const { value, defaultValue, onChange, onBlur, isValid, ...other } = props;
  return (
    <FormControl fullWidth>
      {!other.hasOwnProperty("hidelabel") && (
        <InputLabel htmlFor={kebabCase(other.name)}>
          Mobile Phone {props.inputProps && props.inputProps.required && "*"}
        </InputLabel>
      )}
      <Input
        {...other}
        fullWidth
        value={value}
        defaultValue={defaultValue}
        onChange={onChange}
        onBlur={onBlur}
        id={kebabCase(other.name)}
        inputComponent={MInput}
        error={isValid !== undefined && !isValid}
        autoComplete="nope"
      />
      {isValid !== undefined && (
        <FormHelperText error id={kebabCase(other.name)}>
          {!isValid && <span>Enter a valid Phone Number</span>}
        </FormHelperText>
      )}
    </FormControl>
  );
}
